const EmergencyBanner = () => {
  return (
    <section className="bg-gold py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-navy mb-4">Need Emergency Electrical Service?</h2>
        <p className="text-navy text-lg mb-8">24/7 emergency response available for commercial clients</p>
        <a
          href="tel:+61400000000"
          className="inline-flex items-center gap-3 bg-navy text-white px-10 py-4 rounded-full font-bold text-base tracking-wider hover:bg-navy-light transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-fill text-2xl w-6 h-6 flex items-center justify-center"></i>
          CALL EMERGENCY LINE: 0400 000 000
        </a>
      </div>
    </section>
  );
};

export default EmergencyBanner;